import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox'
import { BadgeStatusEntrega, BtnIcon, CustomDataTableHeader } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'

export default function EntregasCanhotoDataTable({
  entregas,
  totalRecords,
  first,
  rows,
  loading,
  onPage,
  search,
  onSearchChange,
  acaoIcon,
  onClickAcao,
  selectedIds,
  onSelectionChange,
  onToggleAll,
}) {
  const selecionavel = !!onSelectionChange
  const todosSelecionados =
    selecionavel && entregas.length > 0 && entregas.every(e => selectedIds.includes(e.id))

  const onToggle = id =>
    onSelectionChange(
      selectedIds.includes(id) ? selectedIds.filter(s => s !== id) : [...selectedIds, id],
    )

  return (
    <DataTable
      value={entregas}
      emptyMessage="Nenhuma informação foi encontrada"
      header={<CustomDataTableHeader value={search} onChange={onSearchChange} />}
      lazy
      paginator
      rows={rows}
      first={first}
      totalRecords={totalRecords}
      loading={loading}
      onPage={onPage}
      rowsPerPageOptions={[20, 50, 100]}
    >
      {selecionavel && (
        <Column
          header={
            <Checkbox
              onChange={() => onToggleAll(!todosSelecionados)}
              checked={todosSelecionados}
            />
          }
          style={{ width: '3em' }}
          body={rowData => (
            <Checkbox
              checked={selectedIds.includes(rowData.id)}
              onChange={() => onToggle(rowData.id)}
            />
          )}
        />
      )}
      <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
      <Column field="nf_entrega" header="NF Entrega" style={{ width: '8rem' }} />
      <Column field="empresa" header="Empresa" style={{ textAlign: 'center' }} />
      <Column field="placa" header="Placa" style={{ textAlign: 'center' }} />
      <Column field="nomeFantasia" header="Fantasia" />
      <Column field="cidade" header="Cidade" style={{ textAlign: 'center' }} />
      <Column field="cnpj" header="CNPJ" style={{ textAlign: 'center' }} />
      <Column field="qteSkuTotal" header="Qte. Cxs" style={{ width: 100, textAlign: 'center' }} />
      <Column
        field="status"
        header="Status"
        style={tableCellCentered()}
        body={rowData => <BadgeStatusEntrega status={rowData.status} />}
      />
      <Column
        header="Ação"
        style={{ width: '4rem' }}
        body={rowData => <BtnIcon onClick={() => onClickAcao(rowData.id)}>{acaoIcon}</BtnIcon>}
      />
    </DataTable>
  )
}
